/**
 * App Redux Action Types
 */
export const COLLAPSED_SIDEBAR = 'COLLAPSED_SIDEBAR';
export const DARK_MODE = 'DARK_MODE';
export const BOXED_LAYOUT = 'BOXED_LAYOUT';
export const RTL_LAYOUT = 'RTL_LAYOUT';
export const MINI_SIDEBAR = 'MINI_SIDEBAR';
export const SEARCH_FORM_ENABLE = 'SEARCH_FORM_ENABLE';
export const CHANGE_THEME_COLOR = 'CHANGE_THEME_COLOR';
export const TOGGLE_SIDEBAR_IMAGE = 'TOGGLE_SIDEBAR_IMAGE';
export const SET_SIDEBAR_IMAGE = 'SET_SIDEBAR_IMAGE';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const START_USER_TOUR = 'START_USER_TOUR';
export const STOP_USER_TOUR = 'STOP_USER_TOUR';
export const TOGGLE_DARK_SIDENAV = 'TOGGLE_DARK_SIDENAV';
// Agency Sidebar
export const AGENCY_TOGGLE_MENU = 'AGENCY_TOGGLE_MENU';
export const CHANGE_AGENCY_LAYOUT_BG = 'CHANGE_AGENCY_LAYOUT_BG';
// sidebar
export const TOGGLE_MENU = 'TOGGLE_MENU';
// Auth Actions
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNUP_USER_FAILURE = 'SIGNUP_USER_FAILURE';
export const FETCH_PARENT_DETAILS = 'FETCH_PARENT_DETAILS';
export const SIGNUP_USER_REGISTER = 'SIGNUP_USER_REGISTER';
export const SIGNUP_PASSWORD_SET = 'SIGNUP_PASSWORD_SET';
export const FORGOT_PASSWORD_SEND = 'FORGOT_PASSWORD_SEND';
export const TEAM_ACCEPT_TRAVEL = 'TEAM_ACCEPT_TRAVEL';
export const PARENT_ACCEPT_TRAVEL = 'PARENT_ACCEPT_TRAVEL';
// ecommerce
export const ON_DELETE_ITEM_FROM_CART = 'ON_DELETE_ITEM_FROM_CART';
export const ON_QUANTITY_CHANGE = 'ON_QUANTITY_CHANGE';
export const ON_ADD_ITEM_TO_CART = 'ON_ADD_ITEM_TO_CART';

//======================================== Novus Added ================================

export const COMMON_ACTION = 'COMMON_ACTION';
export const ALL_STUDENT = 'ALL_STUDENT';
export const ALL_ADMINMEMBERS = 'ALL_ADMINMEMBERS';
export const ALL_ACADEMYADMINLIST = 'ALL_ACADEMYADMINLIST';
export const ALL_GOLFCOACHMEMBERS = 'ALL_GOLFCOACHMEMBERS';
export const ALL_ACADEMYGOLFCOACH = 'ALL_ACADEMYGOLFCOACH';
export const ALL_SSCOACHMEMBERS = 'ALL_SSCOACHMEMBERS';
export const ALL_ACADEMYSSCOACH = 'ALL_ACADEMYSSCOACH';
export const ALL_PSYCHOLOGISTMEMBERS = 'ALL_PSYCHOLOGISTMEMBERS';
export const ALL_ACADEMYPSYCHOLOGIST = 'ALL_ACADEMYPSYCHOLOGIST';
export const ALL_NUTRITIONISTMEMBERS = 'ALL_NUTRITIONISTMEMBERS';
export const ALL_ACADEMYNUTRITIONIST = 'ALL_ACADEMYNUTRITIONIST';
export const ALL_ACADEMYSTUDENT = 'ALL_ACADEMYSTUDENT';
export const ALL_CLUB = 'ALL_CLUB';
export const STUDENT_FULLDETAILS = 'STUDENT_FULLDETAILS';
export const PARENT_FULLDETAILS = 'PARENT_FULLDETAILS';
export const ALL_MENU_LIST = 'ALL_MENU_LIST';
export const CONTRACT_ALL_COUNT = 'CONTRACT_ALL_COUNT';

export const ALL_PUTTINGEVALUATION = 'ALL_PUTTINGEVALUATION';

//============================ Master  =================================

// Roles
export const ALL_ROLES = 'ALL_ROLES';
export const ROLE_ACTION = 'ROLE_ACTION';
export const ADD_ROLE = 'ADD_ROLE';
export const EDIT_ROLE = 'EDIT_ROLE';
export const STATUS_ROLE = 'STATUS_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';

// Program Inclusion
export const ALL_PROGRAMINCLUSION = 'ALL_PROGRAMINCLUSION';
export const PROGRAMINCLUSION_ACTION = 'PROGRAMINCLUSION_ACTION';
export const ADD_PROGRAMINCLUSION = 'ADD_PROGRAMINCLUSION';
export const EDIT_PROGRAMINCLUSION = 'EDIT_PROGRAMINCLUSION';
export const STATUS_PROGRAMINCLUSION = 'STATUS_PROGRAMINCLUSION';
export const DELETE_PROGRAMINCLUSION = 'DELETE_PROGRAMINCLUSION';


// Academy
export const ALL_ACADEMYS = 'ALL_ACADEMYS';
export const ADD_ACADEMY = 'ADD_ACADEMY';
export const ACADEMY_ACTION = 'ACADEMY_ACTION';
export const EDIT_ACADEMY = 'EDIT_ACADEMY';
export const STATUS_ACADEMY = 'STATUS_ACADEMY';
export const DELETE_ACADEMY = 'DELETE_ACADEMY';

// Feature
export const ALL_FEATURES = 'ALL_FEATURES';
export const ADD_FEATURE = 'ADD_FEATURE';
export const FEATURE_ACTION = 'FEATURE_ACTION';
export const EDIT_FEATURE = 'EDIT_FEATURE';
export const STATUS_FEATURE = 'STATUS_FEATURE';
export const DELETE_FEATURE = 'DELETE_FEATURE';

// Menu
export const ALL_MENUS = 'ALL_MENUS';
export const ADD_MENU = 'ADD_MENU';
export const MENU_ACTION = 'MENU_ACTION';
export const EDIT_MENU = 'EDIT_MENU';
export const STATUS_MENU = 'STATUS_MENU';
export const DELETE_MENU = 'DELETE_MENU';

//Workflow
export const WORKFLOW_ACTION = 'WORKFLOW_ACTION';
export const ADD_ACADEMYADMIN = 'ADD_ACADEMYADMIN';
export const ASSIGN_ACADEMYADMIN = 'ASSIGN_ACADEMYADMIN';
export const ASSIGN_COACH_STUDENT = 'ASSIGN_COACH_STUDENT';
export const ALL_ASSIGNED_STUDENT = 'ALL_ASSIGNED_STUDENT';
export const ASSIGN_PROGRAM_INCLUSION = 'ASSIGN_PROGRAM_INCLUSION';
export const DELETE_ASSIGN_COACH = 'DELETE_ASSIGN_COACH';
export const DELETE_COACH_STUDENT = 'DELETE_COACH_STUDENT';
export const GET_PARTICULAR_ACADEMY_PROGRAM = 'GET_PARTICULAR_ACADEMY_PROGRAM';
export const ASSIGN_PROGRAM_FOR_STUDENT = 'ASSIGN_PROGRAM_FOR_STUDENT'

//Members
export const MEMBER_ACTION = 'MEMBER_ACTION';
export const GET_MEMBERDETAILS = 'GET_MEMBERDETAILS';

//Academy Program
export const ALL_ACADEMYPROGRAM = 'ALL_ACADEMYPROGRAM';
export const ACADEMY_PROGRAM_ACTION = 'ACADEMY_PROGRAM_ACTION';
export const ADD_ACADEMY_PROGRAM ='ADD_ACADEMY_PROGRAM';
export const EDIT_ACADEMY_PROGRAM = 'EDIT_ACADEMY_PROGRAM';
export const STATUS_ACADEMY_PROGRAM ='STATUS_ACADEMY_PROGRAM';
export const DELETE_ACADEMY_PROGRAM = 'DELETE_ACADEMY_PROGRAM';

//============================ Sports Science =================================


//MSK Assessment
export const MSKASSESSMENT_ACTION = 'MSKASSESSMENT_ACTION';
export const ALL_MSKASSESSMENT = 'ALL_MSKASSESSMENT';
export const CHECK_MSKASSESSMENT = 'CHECK_MSKASSESSMENT';
export const CHECK_MSKASSESSMENT_DONE = 'CHECK_MSKASSESSMENT_DONE';
export const CHECK_MSKASSESSMENT_FAILURE = 'CHECK_MSKASSESSMENT_FAILURE';
export const ADD_MSKASSESSMENT = 'ADD_MSKASSESSMENT';
export const ADD_MSKASSESSMENT_SUCCESS = 'ADD_MSKASSESSMENT_SUCCESS';
export const ADD_MSKASSESSMENT_FAILURE = 'ADD_MSKASSESSMENT_FAILURE';
export const FETCH_MSKASSESSMENT = 'FETCH_MSKASSESSMENT';
export const EDIT_MSKASSESSMENT = 'EDIT_MSKASSESSMENT';
export const EDIT_MSKASSESSMENT_SUCCESS = 'EDIT_MSKASSESSMENT_SUCCESS';
export const EDIT_MSKASSESSMENT_FAILURE = 'EDIT_MSKASSESSMENT_FAILURE';
export const DELETE_MSKASSESSMENT_SUCCESS = 'DELETE_MSKASSESSMENT_SUCCESS';
export const DELETE_MSKASSESSMENT_FAILURE = 'DELETE_MSKASSESSMENT_FAILURE';
export const REPORT_MSKASSESSMENT = 'REPORT_MSKASSESSMENT';
export const FETCH_MSKMEDICAL = 'FETCH_MSKMEDICAL';
export const REPORT_MSKDATES = 'REPORT_MSKDATES';

export const ALL_POSTURE_HEAD = 'ALL_POSTURE_HEAD';
export const ALL_POSTURE_SHOULDERS = 'ALL_POSTURE_SHOULDERS';
export const ALL_POSTURE_THORACIC = 'ALL_POSTURE_THORACIC';
export const ALL_POSTURE_LUMBAR = 'ALL_POSTURE_LUMBAR';
export const ALL_POSTURE_PELVIS = 'ALL_POSTURE_PELVIS';
export const ALL_POSTURE_KNEE = 'ALL_POSTURE_KNEE';
export const ALL_POSTURE_FEET = 'ALL_POSTURE_FEET';
export const ALL_POSTURE_GLENOHUMERAL = 'ALL_POSTURE_GLENOHUMERAL';
export const ALL_POSTURE_ABBREIVATION = 'ALL_POSTURE_ABBREIVATION';

// MSK Visualisation
export const ALL_MSKSTUDENT = 'ALL_MSKSTUDENT';
export const MSKVISUAL_ACTION = 'MSKVISUAL_ACTION';
export const ALL_MSKVISUAL = 'ALL_MSKVISUAL';
export const FETCH_MSKYEAR = 'FETCH_MSKYEAR';
export const MSK_VISUALISATION_DETAILS = 'MSK_VISUALISATION_DETAILS';
export const MSK_CREATE_VISUALISATION = 'MSK_CREATE_VISUALISATION';
export const MSK_VISUALISATION_DELETE = 'MSK_VISUALISATION_DELETE';

//MSK Posture
export const ALL_MSKPOSTURE = 'ALL_MSKPOSTURE';
export const ADD_MSKPOSTURE = 'ADD_MSKPOSTURE';
export const MSKPOSTURE_ACTION = 'MSKPOSTURE_ACTION';
export const EDIT_MSKPOSTURE = 'EDIT_MSKPOSTURE';
export const STATUS_MSKPOSTURE = 'STATUS_MSKPOSTURE';
export const DELETE_MSKPOSTURE = 'DELETE_MSKPOSTURE';

export const ALL_SHOULDERPOSTURE = 'ALL_SHOULDERPOSTURE';
export const ADD_SHOULDERPOSTURE = 'ADD_SHOULDERPOSTURE';
export const EDIT_SHOULDERPOSTURE = 'EDIT_SHOULDERPOSTURE';
export const STATUS_SHOULDERPOSTURE = 'STATUS_SHOULDERPOSTURE';
export const DELETE_SHOULDERPOSTURE = 'DELETE_SHOULDERPOSTURE';

export const ALL_THORACICPOSTURE = 'ALL_THORACICPOSTURE';
export const ADD_THORACICPOSTURE = 'ADD_THORACICPOSTURE';
export const EDIT_THORACICPOSTURE = 'EDIT_THORACICPOSTURE';
export const STATUS_THORACICPOSTURE = 'STATUS_THORACICPOSTURE';
export const DELETE_THORACICPOSTURE = 'DELETE_THORACICPOSTURE';

export const ALL_LUMBARPOSTURE = 'ALL_LUMBARPOSTURE';
export const ADD_LUMBARPOSTURE = 'ADD_LUMBARPOSTURE';
export const EDIT_LUMBARPOSTURE = 'EDIT_LUMBARPOSTURE';
export const STATUS_LUMBARPOSTURE = 'STATUS_LUMBARPOSTURE';
export const DELETE_LUMBARPOSTURE = 'DELETE_LUMBARPOSTURE';

export const ALL_PELVISPOSTURE = 'ALL_PELVISPOSTURE';
export const ADD_PELVISPOSTURE = 'ADD_PELVISPOSTURE';
export const EDIT_PELVISPOSTURE = 'EDIT_PELVISPOSTURE';
export const STATUS_PELVISPOSTURE = 'STATUS_PELVISPOSTURE';
export const DELETE_PELVISPOSTURE = 'DELETE_PELVISPOSTURE';

export const ALL_KNEEPOSTURE = 'ALL_KNEEPOSTURE';
export const ADD_KNEEPOSTURE = 'ADD_KNEEPOSTURE';
export const EDIT_KNEEPOSTURE = 'EDIT_KNEEPOSTURE';
export const STATUS_KNEEPOSTURE = 'STATUS_KNEEPOSTURE';
export const DELETE_KNEEPOSTURE = 'DELETE_KNEEPOSTURE';

export const ALL_FEETPOSTURE = 'ALL_FEETPOSTURE';
export const ADD_FEETPOSTURE = 'ADD_FEETPOSTURE';
export const EDIT_FEETPOSTURE = 'EDIT_FEETPOSTURE';
export const STATUS_FEETPOSTURE = 'STATUS_FEETPOSTURE';
export const DELETE_FEETPOSTURE = 'DELETE_FEETPOSTURE';

export const ALL_RHYTHMPOSTURE = 'ALL_RHYTHMPOSTURE';
export const ADD_RHYTHMPOSTURE = 'ADD_RHYTHMPOSTURE';
export const EDIT_RHYTHMPOSTURE = 'EDIT_RHYTHMPOSTURE';
export const STATUS_RHYTHMPOSTURE = 'STATUS_RHYTHMPOSTURE';
export const DELETE_RHYTHMPOSTURE = 'DELETE_RHYTHMPOSTURE';

export const ALL_ABBREVIATIONPOSTURE = 'ALL_ABBREVIATIONPOSTURE';
export const ADD_ABBREVIATIONPOSTURE = 'ADD_ABBREVIATIONPOSTURE';
export const EDIT_ABBREVIATIONPOSTURE = 'EDIT_ABBREVIATIONPOSTURE';
export const STATUS_ABBREVIATIONPOSTURE = 'STATUS_ABBREVIATIONPOSTURE';
export const DELETE_ABBREVIATIONPOSTURE = 'DELETE_ABBREVIATIONPOSTURE';


//SC Assessment
export const SCASSESSMENT_ACTION = 'SCASSESSMENT_ACTION';
export const ALL_SCASSESSMENT = 'ALL_SCASSESSMENT';
export const CHECK_SCASSESSMENT_DONE = 'CHECK_SCASSESSMENT_DONE';
export const ADD_SCASSESSMENT_SUCCESS = 'ADD_SCASSESSMENT_SUCCESS';
export const ADD_SCASSESSMENT_FAILURE = 'ADD_SCASSESSMENT_FAILURE';
export const FETCH_SCASSESSMENT = 'FETCH_SCASSESSMENT';
export const EDIT_SCASSESSMENT_SUCCESS = 'EDIT_SCASSESSMENT_SUCCESS';
export const EDIT_SCASSESSMENT_FAILURE = 'EDIT_SCASSESSMENT_FAILURE';
export const DELETE_SCASSESSMENT_SUCCESS = 'DELETE_SCASSESSMENT_SUCCESS';
export const DELETE_SCASSESSMENT_FAILURE = 'DELETE_SCASSESSMENT_FAILURE';

//SC Visualisation
export const SCVISUAL_ACTION = 'SCVISUAL_ACTION';
export const ALL_SCVISUAL = 'ALL_SCVISUAL';
export const FETCH_SCYEAR = 'FETCH_SCYEAR';
export const SC_VISUALISATION_DETAILS = 'SC_VISUALISATION_DETAILS';
export const SC_CREATE_VISUALISATION = 'SC_CREATE_VISUALISATION';
export const SC_VISUALISATION_DELETE = 'SC_VISUALISATION_DELETE';

//SS Team
export const ALL_SSTEAMS = 'ALL_SSTEAMS';
export const ADD_SSTEAM = 'ADD_SSTEAM';
export const SSTEAM_ACTION = 'SSTEAM_ACTION';
export const EDIT_SSTEAM = 'EDIT_SSTEAM';
export const STATUS_SSTEAM = 'STATUS_SSTEAM';
export const DELETE_SSTEAM = 'DELETE_SSTEAM';

//MKS Finding Chart
export const ALL_FINDINGCHARTS = 'ALL_FINDINGCHARTS';
export const ADD_FINDINGCHART = 'ADD_FINDINGCHART';
export const FINDINGCHART_ACTION = 'FINDINGCHART_ACTION';
export const EDIT_FINDINGCHART = 'EDIT_FINDINGCHART';
export const FETCH_FINDINGCHART = 'FETCH_FINDINGCHART';
export const DELETE_FINDINGCHART = 'DELETE_FINDINGCHART';
export const FETCH_STUDENTFINDINGS = 'FETCH_STUDENTFINDINGS';

export const CHART_FINDINGREPORT= 'CHART_FINDINGREPORT';
export const ALL_FINDINGREPORTS= 'ALL_FINDINGREPORTS';
export const DELETE_FINDINGREPORTS= 'DELETE_FINDINGREPORTS';
export const UPDATE_FINDINGREPORT= 'UPDATE_FINDINGREPORT';

//Injury Chart
export const ALL_INJURYCHARTS = 'ALL_INJURYCHARTS';
export const ADD_INJURYCHART = 'ADD_INJURYCHART';
export const INJURYCHART_ACTION = 'INJURYCHART_ACTION';
export const EDIT_INJURYCHART = 'EDIT_INJURYCHART';
export const FETCH_INJURYCHART = 'FETCH_INJURYCHART';
export const DELETE_INJURYCHART = 'DELETE_INJURYCHART';
export const ALL_STUDENTINJURY = 'ALL_STUDENTINJURY';

//Injury Update
export const ALL_INJURYUPDATES = 'ALL_INJURYUPDATES';
export const ADD_INJURYUPDATE = 'ADD_INJURYUPDATE';
export const INJURYUPDATE_ACTION = 'INJURYUPDATE_ACTION';
export const EDIT_INJURYUPDATE = 'EDIT_INJURYUPDATE';
export const FETCH_INJURYUPDATE = 'FETCH_INJURYUPDATE';
export const DELETE_INJURYUPDATE = 'DELETE_INJURYUPDATE';
//Injury Profile

export const FULL_INJURYDETAIL = 'FULL_INJURYDETAIL';
export const INJURY_UPDATEDETAIL = 'INJURY_UPDATEDETAIL';
export const EDIT_INJURYPROFILE = 'EDIT_INJURYPROFILE';
export const PROFILE_INJURYUPDATE = 'PROFILE_INJURYUPDATE';
export const PROFILE_INJURYREPORT = 'PROFILE_INJURYREPORT';
export const ALL_INJURYREPORTS = 'ALL_INJURYREPORTS';
export const DELETE_INJURYREPORTS = 'DELETE_INJURYREPORTS';

export const ALL_INJURYPROFILE = 'ALL_INJURYPROFILE';
export const FULL_INJURYPROFILE = 'FULL_INJURYPROFILE';


//============================ Travel Form =================================
//Travel From

export const TRAVELFORM_ACTION = 'TRAVELFORM_ACTION';
export const ALL_TRAVELFORM = 'ALL_TRAVELFORM';
export const ADD_TRAVELFORM = 'ADD_TRAVELFORM';
export const FETCH_TRAVELFORM='FETCH_TRAVELFORM';
export const EDIT_TRAVELFORM= 'EDIT_TRAVELFORM';
export const  DELETE_TRAVELFORM_SUCCESS='DELETE_TRAVELFORM_SUCCESS';
export const DELETE_TRAVELFORM_FAILURE='DELETE_TRAVELFORM_FAILURE';
export const UPDATE_TRAVELFORM ='UPDATE_TRAVELFORM';

//MAIL Travel From
export const MAIL_TRAVELFORM ='MAIL_TRAVELFORM';


//travel Report

export const ALL_TRAVELREPORT = 'ALL_TRAVELREPORT';
export const TRAVELREPORT_ACTION = 'TRAVELREPORT_ACTION';

// Travel Cumulative Report
export const ALL_CUMULATIVEREPORT = 'ALL_CUMULATIVEREPORT';
export const CUMULATIVEREPORT_ACTION = 'CUMULATIVEREPORT_ACTION';

//============================ Golf Module =================================

// Practice Schedule
export const PRACTICESCHEDULE_ACTION = 'PRACTICESCHEDULE_ACTION';
export const STUDENT_PRACTICESCHEDULE = 'STUDENT_PRACTICESCHEDULE';
export const ALL_PSSHOTS = 'ALL_PSSHOTS';
export const SELECT_SHOTTYPE = 'SELECT_SHOTTYPE';
export const ADD_PRACTICESCHEDULE_SUCCESS = 'ADD_PRACTICESCHEDULE_SUCCESS';

//Practice Drill
export const PRACTICEDRILL_ACTION = 'PRACTICEDRILL_ACTION';
export const ALL_PRACTICEDRILL = 'ALL_PRACTICEDRILL';
export const ADD_PRACTICEDRILL = 'ADD_PRACTICEDRILL';
export const FETCH_PRACTICEDRILL = 'FETCH_PRACTICEDRILL';
export const EDIT_PRACTICEDRILL = 'EDIT_PRACTICEDRILL';
export const DELETE_PRACTICEDRILL = 'DELETE_PRACTICEDRILL';

export const VISITOR_ACTION = 'VISITOR_ACTION';
export const ALL_VISITOR = 'ALL_VISITOR';
export const ADD_VISITOR = 'ADD_VISITOR';
export const FETCH_VISITOR = 'FETCH_VISITOR';
export const EDIT_VISITOR = 'EDIT_VISITOR';
export const DELETE_VISITOR = 'DELETE_VISITOR';

export const AVAILABLE_STUDENTS_REPORT = 'AVAILABLE_STUDENTS_REPORT';

//Tournament List
export const TOURNAMENTLIST_ACTION = 'TOURNAMENTLIST_ACTION';
export const ALL_TOURNAMENTLIST = 'ALL_TOURNAMENTLIST';
export const ADD_TOURNAMENTLIST = 'ADD_TOURNAMENTLIST';
export const FETCH_TOURNAMENTLIST = 'FETCH_TOURNAMENTLIST';
export const EDIT_TOURNAMENTLIST = 'EDIT_TOURNAMENTLIST';
export const DELETE_TOURNAMENTLIST = 'DELETE_TOURNAMENTLIST';

// Tournament Process
export const TOURNAMENTPROCESS_ACTION = 'TOURNAMENTPROCESS_ACTION';
export const ALL_TOURNAMENTPROCESS = 'ALL_TOURNAMENTPROCESS';
export const ADD_TOURNAMENTPROCESS = 'ADD_TOURNAMENTPROCESS';
export const FETCH_TOURNAMENTPROCESS = 'FETCH_TOURNAMENTPROCESS';
export const EDIT_TOURNAMENTPROCESS = 'EDIT_TOURNAMENTPROCESS';
export const DELETE_TOURNAMENTPROCESS = 'DELETE_TOURNAMENTPROCESS';
export const FETCH_TOURNAMENTPROCESSREPORT = 'FETCH_TOURNAMENTPROCESSREPORT';

// Tournament Score
export const TOURNAMENTSCORE_ACTION = 'TOURNAMENTSCORE_ACTION';
export const ALL_TOURNAMENTSCORE = 'ALL_TOURNAMENTSCORE';
export const ADD_TOURNAMENTSCORE = 'ADD_TOURNAMENTSCORE';
export const FETCH_TOURNAMENTSCORE = 'FETCH_TOURNAMENTSCORE';
export const EDIT_TOURNAMENTSCORE = 'EDIT_TOURNAMENTSCORE';
export const DELETE_TOURNAMENTSCORE = 'DELETE_TOURNAMENTSCORE';
export const FETCH_TOURNAMENTSCORECHART = 'FETCH_TOURNAMENTSCORECHART';

// Player Intervention Log
export const PLAYERINTERVENTION_ACTION = 'PLAYERINTERVENTION_ACTION';
export const FETCH_PLAYERINTERVENTION = 'FETCH_PLAYERINTERVENTION';
export const FETCH_PLAYERTECHSAMLAB = 'FETCH_PLAYERTECHSAMLAB';
export const FETCH_PLAYERTECHCAPTO = 'FETCH_PLAYERTECHCAPTO';
export const FETCH_PLAYERTECHLAUNCH = 'FETCH_PLAYERTECHLAUNCH';
export const FETCH_PLAYERTECHHACK = 'FETCH_PLAYERTECHHACK';
export const FETCH_PLAYERTECHFSIRON = 'FETCH_PLAYERTECHFSIRON';
export const FETCH_PLAYERTECHFSDRIVER = 'FETCH_PLAYERTECHFSDRIVER';
export const FETCH_PLAYERTECHWEDGE = 'FETCH_PLAYERTECHWEDGE';
export const FETCH_PLAYERTECHCOURSE = 'FETCH_PLAYERTECHCOURSE';
export const FETCH_PLAYERTECHSPEED = 'FETCH_PLAYERTECHSPEED';
// FS IRONS
export const FSIRONS_ACTION = 'FSIRONS_ACTION';
export const ALL_FSIRONS = 'ALL_FSIRONS';
export const ADD_FSIRONS = 'ADD_FSIRONS';
export const FETCH_FSIRONS = 'FETCH_FSIRONS';
export const EDIT_FSIRONS = 'EDIT_FSIRONS';
export const DELETE_FSIRONS = 'DELETE_FSIRONS';
// FS DRIVER
export const FSDRIVER_ACTION = 'FSDRIVER_ACTION';
export const ALL_FSDRIVER = 'ALL_FSDRIVER';
export const ADD_FSDRIVER = 'ADD_FSDRIVER';
export const FETCH_FSDRIVER = 'FETCH_FSDRIVER';
export const EDIT_FSDRIVER = 'EDIT_FSDRIVER';
export const DELETE_FSDRIVER = 'DELETE_FSDRIVER';
// WEDGE PLAY
export const WEDGEPLAY_ACTION = 'WEDGEPLAY_ACTION';
export const ALL_WEDGEPLAY = 'ALL_WEDGEPLAY';
export const ADD_WEDGEPLAY = 'ADD_WEDGEPLAY';
export const FETCH_WEDGEPLAY = 'FETCH_WEDGEPLAY';
export const EDIT_WEDGEPLAY = 'EDIT_WEDGEPLAY';
export const DELETE_WEDGEPLAY = 'DELETE_WEDGEPLAY';

//================ ON COURSE TEST =========================================
// BUNKER PLAY
export const OCTBUNKER_ACTION = 'OCTBUNKER_ACTION';
export const ALL_OCTBUNKER = 'ALL_OCTBUNKER';
export const ADD_OCTBUNKER = 'ADD_OCTBUNKER';
export const FETCH_OCTBUNKER = 'FETCH_OCTBUNKER';
export const EDIT_OCTBUNKER = 'EDIT_OCTBUNKER';
export const DELETE_OCTBUNKER = 'DELETE_OCTBUNKER';
export const FETCH_OCTBUNKERCHART = 'FETCH_OCTBUNKERCHART';
export const FETCH_BUNKERSHOTCHART = 'FETCH_BUNKERSHOTCHART';
// WEDGE PLAY
export const OCTWEDGE_ACTION = 'OCTWEDGE_ACTION';
export const ALL_OCTWEDGE = 'ALL_OCTWEDGE';
export const ADD_OCTWEDGE = 'ADD_OCTWEDGE';
export const FETCH_OCTWEDGE = 'FETCH_OCTWEDGE';
export const EDIT_OCTWEDGE = 'EDIT_OCTWEDGE';
export const DELETE_OCTWEDGE = 'DELETE_OCTWEDGE';
export const FETCH_OCTWEDGECHART = 'FETCH_OCTWEDGECHART';
export const FETCH_WEDGESHOTCHART = 'FETCH_WEDGESHOTCHART';
// SHORT GAME
export const OCTSHORTGAME_ACTION = 'OCTSHORTGAME_ACTION';
export const ALL_OCTSHORTGAME = 'ALL_OCTSHORTGAME';
export const ALL_OCTSHORTGAMESHOT = 'ALL_OCTSHORTGAMESHOT';
export const ADD_OCTSHORTGAME = 'ADD_OCTSHORTGAME';
export const FETCH_OCTSHORTGAME = 'FETCH_OCTSHORTGAME';
export const EDIT_OCTSHORTGAME = 'EDIT_OCTSHORTGAME';
export const DELETE_OCTSHORTGAME = 'DELETE_OCTSHORTGAME';
export const FETCH_OCTSHORTGAMECHART = 'FETCH_OCTSHORTGAMECHART';
export const FETCH_SHORTSHOTCHART = 'FETCH_SHORTSHOTCHART';
// APPROACH SHOT
export const OCTAPPROACH_ACTION = 'OCTAPPROACH_ACTION';
export const ALL_OCTAPPROACH = 'ALL_OCTAPPROACH';
export const ALL_OCTCLUBSPEED = 'ALL_OCTCLUBSPEED';
export const ADD_OCTAPPROACH = 'ADD_OCTAPPROACH';
export const FETCH_OCTAPPROACH = 'FETCH_OCTAPPROACH';
export const EDIT_OCTAPPROACH = 'EDIT_OCTAPPROACH';
export const DELETE_OCTAPPROACH = 'DELETE_OCTAPPROACH';
export const FETCH_OCTAPPROACHCHART = 'FETCH_OCTAPPROACHCHART';
export const FETCH_APPROACHSHOTCHART = 'FETCH_APPROACHSHOTCHART';
// DRIVING
export const OCTDRIVING_ACTION = 'OCTDRIVING_ACTION';
export const ALL_OCTDRIVING = 'ALL_OCTDRIVING';
export const ALL_OCTCLUBSHOT = 'ALL_OCTCLUBSHOT';
export const ADD_OCTDRIVING = 'ADD_OCTDRIVING';
export const FETCH_OCTDRIVING = 'FETCH_OCTDRIVING';
export const EDIT_OCTDRIVING = 'EDIT_OCTDRIVING';
export const DELETE_OCTDRIVING = 'DELETE_OCTDRIVING';
export const FETCH_OCTDRIVINGCHART = 'FETCH_OCTDRIVINGCHART';
export const FETCH_DRIVINGSHOTCHART = 'FETCH_DRIVINGSHOTCHART';

//=============== On Range Test ==========================================
// Chipping
export const ORTCHIPPING_ACTION = 'ORTCHIPPING_ACTION';
export const ALL_ORTCHIPPING = 'ALL_ORTCHIPPING';
export const ADD_ORTCHIPPING = 'ADD_ORTCHIPPING';
export const FETCH_ORTCHIPPING = 'FETCH_ORTCHIPPING';
export const EDIT_ORTCHIPPING = 'EDIT_ORTCHIPPING';
export const DELETE_ORTCHIPPING = 'DELETE_ORTCHIPPING';
export const FETCH_ORTCHIPPINGCHART = 'FETCH_ORTCHIPPINGCHART';
export const FETCH_ORTCHIPPINGSHOTCHART = 'FETCH_ORTCHIPPINGSHOTCHART';
// Bunker
export const ORTBUNKER_ACTION = 'ORTBUNKER_ACTION';
export const ALL_ORTBUNKER = 'ALL_ORTBUNKER';
export const ADD_ORTBUNKER = 'ADD_ORTBUNKER';
export const FETCH_ORTBUNKER = 'FETCH_ORTBUNKER';
export const EDIT_ORTBUNKER = 'EDIT_ORTBUNKER';
export const DELETE_ORTBUNKER = 'DELETE_ORTBUNKER';
export const FETCH_ORTBUNKERCHART = 'FETCH_ORTBUNKERCHART';
export const FETCH_ORTBUNKERSHOTCHART = 'FETCH_ORTBUNKERSHOTCHART';
// Wedge
export const ORTWEDGEPLAY_ACTION = 'ORTWEDGEPLAY_ACTION';
export const ALL_ORTWEDGEPLAY = 'ALL_ORTWEDGEPLAY';
export const ADD_ORTWEDGEPLAY = 'ADD_ORTWEDGEPLAY';
export const FETCH_ORTWEDGEPLAY = 'FETCH_ORTWEDGEPLAY';
export const EDIT_ORTWEDGEPLAY = 'EDIT_ORTWEDGEPLAY';
export const DELETE_ORTWEDGEPLAY = 'DELETE_ORTWEDGEPLAY';
export const FETCH_ORTWEDGECHART = 'FETCH_ORTWEDGECHART';
export const FETCH_ORTWEDGESHOTCHART = 'FETCH_ORTWEDGESHOTCHART';
// Short Game
export const ORTSHORTGAME_ACTION = 'ORTSHORTGAME_ACTION';
export const ALL_ORTSHORTGAME = 'ALL_ORTSHORTGAME';
export const ADD_ORTSHORTGAME = 'ADD_ORTSHORTGAME';
export const FETCH_ORTSHORTGAME = 'FETCH_ORTSHORTGAME';
export const EDIT_ORTSHORTGAME = 'EDIT_ORTSHORTGAME';
export const DELETE_ORTSHORTGAME = 'DELETE_ORTSHORTGAME';
export const FETCH_ORTSHORTGAMECHART = 'FETCH_ORTSHORTGAMECHART';
export const FETCH_ORTSHORTGAMESHOTCHART = 'FETCH_ORTSHORTGAMESHOTCHART';
// Iron
export const ORTIRON_ACTION = 'ORTIRON_ACTION';
export const ALL_ORTIRON = 'ALL_ORTIRON';
export const ADD_ORTIRON = 'ADD_ORTIRON';
export const FETCH_ORTIRON = 'FETCH_ORTIRON';
export const EDIT_ORTIRON = 'EDIT_ORTIRON';
export const DELETE_ORTIRON = 'DELETE_ORTIRON';
export const FETCH_ORTIRONCHART = 'FETCH_ORTIRONCHART';
export const FETCH_ORTIRONSHOTCHART = 'FETCH_ORTIRONSHOTCHART';
// Driving
export const ORTDRIVING_ACTION = 'ORTDRIVING_ACTION';
export const ALL_ORTDRIVING = 'ALL_ORTDRIVING';
export const ADD_ORTDRIVING = 'ADD_ORTDRIVING';
export const FETCH_ORTDRIVING = 'FETCH_ORTDRIVING';
export const EDIT_ORTDRIVING = 'EDIT_ORTDRIVING';
export const DELETE_ORTDRIVING = 'DELETE_ORTDRIVING';
export const FETCH_ORTDRIVINGCHART = 'FETCH_ORTDRIVINGCHART';
export const FETCH_ORTDRIVINGSHOTCHART = 'FETCH_ORTDRIVINGSHOTCHART';
// Long Game
export const ORTLONGGAME_ACTION = 'ORTLONGGAME_ACTION';
export const ALL_ORTLONGGAME = 'ALL_ORTLONGGAME';
export const ADD_ORTLONGGAME = 'ADD_ORTLONGGAME';
export const FETCH_ORTLONGGAME = 'FETCH_ORTLONGGAME';
export const EDIT_ORTLONGGAME = 'EDIT_ORTLONGGAME';
export const DELETE_ORTLONGGAME = 'DELETE_ORTLONGGAME';
export const FETCH_ORTLONGGAMECHART = 'FETCH_ORTLONGGAMECHART';
export const FETCH_ORTLONGGAMESHOTCHART = 'FETCH_ORTLONGGAMESHOTCHART';
// Course Scoring
export const OCSCORING_ACTION = 'OCSCORING_ACTION';
export const ALL_OCSCORING = 'ALL_OCSCORING';
export const ADD_OCSCORING = 'ADD_OCSCORING';
export const FETCH_OCSCORING = 'FETCH_OCSCORING';
export const EDIT_OCSCORING = 'EDIT_OCSCORING';
export const DELETE_OCSCORING = 'DELETE_OCSCORING';
export const FETCH_OCSCORINGCHART = 'FETCH_OCSCORINGCHART';
//================== PUTT MODULE ==================================
// Putt Performance
export const PUTTPERFORMANCE_ACTION = 'PUTTPERFORMANCE_ACTION';
export const ALL_PUTTPERFORMANCE = 'ALL_PUTTPERFORMANCE';
export const ADD_PUTTPERFORMANCE = 'ADD_PUTTPERFORMANCE';
export const FETCH_PUTTPERFORMANCE = 'FETCH_PUTTPERFORMANCE';
export const EDIT_PUTTPERFORMANCE = 'EDIT_PUTTPERFORMANCE';
export const DELETE_PUTTPERFORMANCE = 'DELETE_PUTTPERFORMANCE';
export const FETCH_PUTTDISTANCE = 'FETCH_PUTTDISTANCE';
export const FETCH_PUTTPERFORMANCECHART = 'FETCH_PUTTPERFORMANCECHART';

// Putt Broadie drill 5Ft
export const PUTTBDFIVEPOINTS_ACTION = 'PUTTBDFIVEPOINTS_ACTION';
export const ALL_PUTTBDFIVEPOINTS = 'ALL_PUTTBDFIVEPOINTS';
export const ADD_PUTTBDFIVEPOINTS = 'ADD_PUTTBDFIVEPOINTS';
export const ALL_PUTTBDFIVEPUTTS = 'ALL_PUTTBDFIVEPUTTS';
export const ADD_PUTTBDFIVEPUTTS = 'ADD_PUTTBDFIVEPUTTS';
// Putt Broadie drill 10Ft
export const PUTTBDTENPOINTS_ACTION = 'PUTTBDTENPOINTS_ACTION';
export const ALL_PUTTBDTENPOINTS = 'ALL_PUTTBDTENPOINTS';
export const ADD_PUTTBDTENPOINTS = 'ADD_PUTTBDTENPOINTS';
export const ALL_PUTTBDTENPUTTS = 'ALL_PUTTBDTENPUTTS';
export const ADD_PUTTBDTENPUTTS = 'ADD_PUTTBDTENPUTTS';
// Putt Broadie drill 15Ft
export const PUTTBDFIFTEENPOINTS_ACTION = 'PUTTBDFIFTEENPOINTS_ACTION';
export const ALL_PUTTBDFIFTEENPOINTS = 'ALL_PUTTBDFIFTEENPOINTS';
export const ADD_PUTTBDFIFTEENPOINTS = 'ADD_PUTTBDFIFTEENPOINTS';
export const ALL_PUTTBDFIFTEENPUTTS = 'ALL_PUTTBDFIFTEENPUTTS';
export const ADD_PUTTBDFIFTEENPUTTS = 'ADD_PUTTBDFIFTEENPUTTS';
// Putt Broadie drill 100Ft
export const PUTTBDHUNDREDPOINTS_ACTION = 'PUTTBDHUNDREDPOINTS_ACTION';
export const ALL_PUTTBDHUNDREDPOINTS = 'ALL_PUTTBDHUNDREDPOINTS';
export const ADD_PUTTBDHUNDREDPOINTS = 'ADD_PUTTBDHUNDREDPOINTS';
//================ CONTRACT ===============================================
// Contract StudentList 
export const CONTRACT_STUDENT_ACTION = 'CONTRACT_STUDENT_ACTION';
export const CONTRACT_ALL_STUDENT= 'CONTRACT_ALL_STUDENT';
export const CONTRACT_ADD_STUDENT = 'CONTRACT_ADD_STUDENT';
export const CONTRACT_FETCH_STUDENT = 'CONTRACT_FETCH_STUDENT';
export const CONTRACT_EDIT_STUDENT = 'CONTRACT_EDIT_STUDENT';
export const CONTRACT_DELETE_STUDENT = 'CONTRACT_DELETE_STUDENT';
export const CONTRACT_UPDATE_ENROLMENT = 'CONTRACT_UPDATE_ENROLMENT';
export const CONTRACT_UPDATE_NOTES = 'CONTRACT_UPDATE_NOTES';
export const CONTRACT_PROGRAM_INCLUSION = 'CONTRACT_PROGRAM_INCLUSION';
export const DELETE_PROGRAM_INCLUSION = 'DELETE_PROGRAM_INCLUSION';
export const CONTRACT_UPLOAD_DOCUMENT = 'CONTRACT_UPLOAD_DOCUMENT';
export const CONTRACT_FETCH_DCOUMENT = 'CONTRACT_FETCH_DCOUMENT';
export const DELETE_CONTRACT_DOCUMENT = 'DELETE_CONTRACT_DOCUMENT';
export const ADD_PROGRAM_INCLUSION = 'ADD_PROGRAM_INCLUSION';
export const ADD_AGREEMENT = 'ADD_AGREEMENT';
export const FETCH_AGREEMENT = 'FETCH_AGREEMENT';
export const FETCH_AGREEMENT_PROGRAMINCLUSION = 'FETCH_AGREEMENT_PROGRAMINCLUSION';
export const SEND_AGREEMENT = 'SEND_AGREEMENT';
export const EDIT_AGREEMENT = 'EDIT_AGREEMENT';
export const ACCEPT_AGREEMENT = 'ACCEPT_AGREEMENT';
export const ALL_FINANCIAL_YEAR = 'ALL_FINANCIAL_YEAR';
export const ALL_AGREEMENT_TYPE = 'ALL_AGREEMENT_TYPE';
export const ALL_AGREEMENT_FOR = 'ALL_AGREEMENT_FOR';
export const ALL_AGREEMENT_PROGRAM = 'ALL_AGREEMENT_PROGRAM';
export const ALL_GOLF_PROGRAM = 'ALL_GOLF_PROGRAM';
export const DELETE_STUDENT_AGREEMENT = 'DELETE_STUDENT_AGREEMENT';
export const CANCEL_STUDENT_AGREEMENT = 'CANCEL_STUDENT_AGREEMENT';
export const FETCH_PROGRAM_DETAILS = 'FETCH_PROGRAM_DETAILS';
export const ADD_PROGRAM_DETAILS ='ADD_PROGRAM_DETAILS';
export const PARENT_ALL_CONTRACT ='PARENT_ALL_CONTRACT';
export const PARENT_ALL_DOCUMENT ='PARENT_ALL_DOCUMENT';

// CONTRACT PROGRAM INCLUSION 
export const PROGRAM_INCLUSION_ACTION1 = 'PROGRAM_INCLUSION_ACTION1';
export const GET_PROGRAM_INCLUSION= 'GET_PROGRAM_INCLUSION';
export const ADD_PROGRAM_INCLUSION1= 'ADD_PROGRAM_INCLUSION1';
export const DELETE_PROGRAM_INCLUSIONS= 'DELETE_PROGRAM_INCLUSIONS';
export const EDIT_PROGRAM_INCLUSIONS= 'EDIT_PROGRAM_INCLUSIONS';

// CONTRACT DASHBOARD
export const CONTRACT_PENDING_ACTION= 'CONTRACT_PENDING_ACTION';
export const GET_PENDING_CONTRACT= 'GET_PENDING_CONTRACT';
export const GET_ENDING_CONTRACT ='GET_ENDING_CONTRACT';
export const GET_CANCEL_CONTRACT = 'GET_CANCEL_CONTRACT';
export const GET_ACCEPT_CONTRACT = 'GET_ACCEPT_CONTRACT';
export const GET_NEW_CONTRACT = 'GET_NEW_CONTRACT';
export const GET_STUDENT_PROGRAM_INCLUSION = 'GET_STUDENT_PROGRAM_INCLUSION';
export const GET_STUDENT_PROGRAM = 'GET_STUDENT_PROGRAM';
export const GET_MONTH_CONTRACT = 'GET_MONTH_CONTRACT';
export const GET_CONTRACT_INSTALLMENT = 'GET_CONTRACT_INSTALLMENT';
export const UPDATE_INSTALLMENT_STATUS = 'UPDATE_INSTALLMENT_STATUS';
export const SEND_EMAIL_CONTRACT_NOTIFICATION = 'SEND_EMAIL_CONTRACT_NOTIFICATION';

// CONTRACT RENEWAL
export const CONTRACT_RENEWAL_ACTION = 'CONTRACT_RENEWAL_ACTION';
export const CONTRACT_ALL_RENEWAL = 'CONTRACT_ALL_RENEWAL';
export const CONTRACT_ADD_RENEWAL = 'CONTRACT_ADD_RENEWAL';
export const CONTRACT_FETCH_RENEWAL = 'CONTRACT_FETCH_RENEWAL';
export const CONTRACT_EDIT_RENEWAL = 'CONTRACT_EDIT_RENEWAL';
export const CONTRACT_DELETE_RENEWAL = 'CONTRACT_DELETE_RENEWAL';

// STUDENT ALL DOWNLOAD
export const STUDENT_DETAILS_ACTION= 'STUDENT_DETAILS_ACTION';
export const GET_STUDENT_DETAILS= 'GET_STUDENT_DETAILS';

// STUDENT ID CARD 
export const DETAILS_ID_CARD = 'DETAILS_ID_CARD';
export const DOWNLOAD_STUDENT_CARD = 'DOWNLOAD_STUDENT_CARD';
export const UPLOAD_STUDENT_IMAGE = 'UPLOAD_STUDENT_IMAGE';
// SAM LAB
export const SAMLABREPORT_ACTION = 'SAMLABREPORT_ACTION';
export const ALL_SAMLABREPORT = 'ALL_SAMLABREPORT';
export const ADD_SAMLABREPORT = 'ADD_SAMLABREPORT';
export const FETCH_SAMLABREPORT = 'FETCH_SAMLABREPORT';
export const DELETE_SAMLABREPORT = 'DELETE_SAMLABREPORT';
export const EDIT_SAMLABREPORT = 'EDIT_SAMLABREPORT';
// CAPTO PUTTING
export const CAPTOREPORT_ACTION = 'CAPTOREPORT_ACTION';
export const ALL_CAPTOREPORT = 'ALL_CAPTOREPORT';
export const ADD_CAPTOREPORT = 'ADD_CAPTOREPORT';
export const DELETE_CAPTOREPORT = 'DELETE_CAPTOREPORT';
export const FETCH_CAPTOREPORT = 'FETCH_CAPTOREPORT';
export const EDIT_CAPTOREPORT = 'EDIT_CAPTOREPORT';
// LAUNCH MONITOR PUTTING
export const LAUNCHREPORT_ACTION = 'LAUNCHREPORT_ACTION';
export const ALL_LAUNCHREPORT = 'ALL_LAUNCHREPORT';
export const ADD_LAUNCHREPORT = 'ADD_LAUNCHREPORT';
export const DELETE_LAUNCHREPORT = 'DELETE_LAUNCHREPORT';
export const EDIT_LAUNCHREPORT = 'EDIT_LAUNCHREPORT';
// HACKMOTION SESSION
export const HACKMOTIONREPORT_ACTION = 'HACKMOTIONREPORT_ACTION';
export const ALL_HACKMOTIONREPORT = 'ALL_HACKMOTIONREPORT';
export const ADD_HACKMOTIONREPORT = 'ADD_HACKMOTIONREPORT';
export const DELETE_HACKMOTIONREPORT = 'DELETE_HACKMOTIONREPORT';
export const EDIT_HACKMOTIONREPORT = 'EDIT_HACKMOTIONREPORT';
// SPEED CHECK
export const SPEEDCHECK_ACTION = 'SPEEDCHECK_ACTION';
export const ALL_SPEEDCHECK = 'ALL_SPEEDCHECK';
export const ADD_SPEEDCHECK = 'ADD_SPEEDCHECK';
export const FETCH_SPEEDCHECK = 'FETCH_SPEEDCHECK';
export const EDIT_SPEEDCHECK = 'EDIT_SPEEDCHECK';
export const DELETE_SPEEDCHECK = 'DELETE_SPEEDCHECK';
// COURSE INTERVENTION
export const COURSEINTERVENTION_ACTION = 'COURSEINTERVENTION_ACTION';
export const FETCH_COURSEINTERVENTION = 'FETCH_COURSEINTERVENTION';
export const ADD_COURSEINTERVENTION = 'ADD_COURSEINTERVENTION';
export const GET_COURSEINTERVENTION = 'GET_COURSEINTERVENTION';
export const EDIT_COURSEINTERVENTION = 'EDIT_COURSEINTERVENTION';
export const DELETE_COURSEINTERVENTION = 'DELETE_COURSEINTERVENTION';
// RANGE INTERVENTION PUTTING
export const RANGEPUTTING_ACTION = 'RANGEPUTTING_ACTION';
export const FETCH_RANGEPUTTING = 'FETCH_RANGEPUTTING';
export const ADD_RANGEPUTTING = 'ADD_RANGEPUTTING';
export const GET_RANGEPUTTING = 'GET_RANGEPUTTING';
export const EDIT_RANGEPUTTING = 'EDIT_RANGEPUTTING';
export const DELETE_RANGEPUTTING = 'DELETE_RANGEPUTTING';
// RANGE INTERVENTION IRONPLAY
export const RANGEIRONPLAY_ACTION = 'RANGEIRONPLAY_ACTION';
export const FETCH_RANGEIRONPLAY = 'FETCH_RANGEIRONPLAY';
export const ADD_RANGEIRONPLAY = 'ADD_RANGEIRONPLAY';
export const GET_RANGEIRONPLAY = 'GET_RANGEIRONPLAY';
export const EDIT_RANGEIRONPLAY = 'EDIT_RANGEIRONPLAY';
export const DELETE_RANGEIRONPLAY = 'DELETE_RANGEIRONPLAY';
// RANGE INTERVENTION FAIRWAY
export const RANGEFAIRWAY_ACTION = 'RANGEFAIRWAY_ACTION';
export const FETCH_RANGEFAIRWAY = 'FETCH_RANGEFAIRWAY';
export const ADD_RANGEFAIRWAY = 'ADD_RANGEFAIRWAY';
export const GET_RANGEFAIRWAY = 'GET_RANGEFAIRWAY';
export const EDIT_RANGEFAIRWAY = 'EDIT_RANGEFAIRWAY';
export const DELETE_RANGEFAIRWAY = 'DELETE_RANGEFAIRWAY';
// RANGE INTERVENTION DRIVER
export const RANGEDRIVER_ACTION = 'RANGEDRIVER_ACTION';
export const FETCH_RANGEDRIVER = 'FETCH_RANGEDRIVER';
export const ADD_RANGEDRIVER = 'ADD_RANGEDRIVER';
export const GET_RANGEDRIVER = 'GET_RANGEDRIVER';
export const EDIT_RANGEDRIVER = 'EDIT_RANGEDRIVER';
export const DELETE_RANGEDRIVER = 'DELETE_RANGEDRIVER';
// RANGE INTERVENTION SPECIALITY
export const RANGESPECIALITY_ACTION = 'RANGESPECIALITY_ACTION';
export const FETCH_RANGESPECIALITY = 'FETCH_RANGESPECIALITY';
export const ADD_RANGESPECIALITY = 'ADD_RANGESPECIALITY';
export const GET_RANGESPECIALITY = 'GET_RANGESPECIALITY';
export const EDIT_RANGESPECIALITY = 'EDIT_RANGESPECIALITY';
export const DELETE_RANGESPECIALITY = 'DELETE_RANGESPECIALITY';
// RANGE INTERVENTION WEDGEPLAY
export const RANGEWEDGEPLAY_ACTION = 'RANGEWEDGEPLAY_ACTION';
export const FETCH_RANGEWEDGEPLAY = 'FETCH_RANGEWEDGEPLAY';
export const ADD_RANGEWEDGEPLAY = 'ADD_RANGEWEDGEPLAY';
export const GET_RANGEWEDGEPLAY = 'GET_RANGEWEDGEPLAY';
export const EDIT_RANGEWEDGEPLAY = 'EDIT_RANGEWEDGEPLAY';
export const DELETE_RANGEWEDGEPLAY = 'DELETE_RANGEWEDGEPLAY';
// RANGE INTERVENTION CHIPPING
export const RANGECHIPPING_ACTION = 'RANGECHIPPING_ACTION';
export const FETCH_RANGECHIPPING = 'FETCH_RANGECHIPPING';
export const ADD_RANGECHIPPING = 'ADD_RANGECHIPPING';
export const GET_RANGECHIPPING = 'GET_RANGECHIPPING';
export const EDIT_RANGECHIPPING = 'EDIT_RANGECHIPPING';
export const DELETE_RANGECHIPPING = 'DELETE_RANGECHIPPING';
// RANGE INTERVENTION BUNKER
export const RANGEBUNKERPLAY_ACTION = 'RANGEBUNKERPLAY_ACTION';
export const FETCH_RANGEBUNKERPLAY = 'FETCH_RANGEBUNKERPLAY';
export const ADD_RANGEBUNKERPLAY = 'ADD_RANGEBUNKERPLAY';
export const GET_RANGEBUNKERPLAY = 'GET_RANGEBUNKERPLAY';
export const EDIT_RANGEBUNKERPLAY = 'EDIT_RANGEBUNKERPLAY';
export const DELETE_RANGEBUNKERPLAY = 'DELETE_RANGEBUNKERPLAY';
